import axios from 'axios';
import { APIResponse, LoginSource } from '@arema/components/Classes';
import { USER_AUTH_EVENT, USER_AUTH_KEY, USER_AUTH_TOKENS_EVENT, USER_AUTH_TOKENS_KEY, UserLogin } from './AuthClasses';
export const ROOT_URL = process.env.REACT_APP_API_URL;
export const CDN_URL = process.env.REACT_APP_CDN_URL;
export const DEBUG = process.env.REACT_APP_DEBUG=='1';
export const CAPTCHA_ACTIVE = process.env.REACT_APP_CAPTCHA_ACTIVE=='1';
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA;

async function post<T=any>(endpoint: string, data?: any, headers?: any) : Promise<APIResponse<T>>{
	var options = {
		headers: {
			'show-code': DEBUG ? 1 : 0,
			'Content-Type': 'application/json',
			...headers
		}
	}
	if(data instanceof FormData){
		options.headers['Content-Type'] = 'multipart/form-data';
	}

	try{
		var ENDPOINT = `${ROOT_URL}/auth/${endpoint}`;
		if(DEBUG) console.log("POST "+ENDPOINT);
		var res = await axios.post(ENDPOINT, data, options);
		if(DEBUG) console.log(` => Response: ${(res.headers['content-length']/1024).toFixed(2)} KB`);
		return res.data as APIResponse<T>;
	}catch(err){
		if(DEBUG) console.error(err);
		return {
			error: true, 
			message: 'Hubo un error inesperado (API-LCL-1)',
			code: 'API-LCL-1',
		}
	}
}

var dispatchLoginEvent = (user: UserLogin)=>{
	if(!user || !user?.tokens) return;
	window.localStorage.setItem(USER_AUTH_KEY, JSON.stringify({
		...user,
		tokens: {
			refresh: user.tokens.refresh,
			refresh_expires: user.tokens.refresh_expires
		}
	}));
	window.localStorage.setItem(USER_AUTH_TOKENS_KEY, JSON.stringify({
		source: user.tokens.source,
		access: user.tokens.access,
		expires: user.tokens.expires,
	}));

	setTimeout(()=>{
		window.dispatchEvent(new Event(USER_AUTH_EVENT));
		window.dispatchEvent(new Event(USER_AUTH_TOKENS_EVENT));
	}, 50);
}

var login = async (email: string, password: string, source: LoginSource, captcha: string, remember: boolean=false, code: string, pdv_token: string=null, systems: boolean=false)=>{
	var res = await post<UserLogin>('login', { email, password, source, remember, captcha, code, systems }, pdv_token ? { 'pdv-token': pdv_token } : null);
	if(!res.error && res.data.tokens){
		dispatchLoginEvent(res.data);
	}
	return res;
}

var loginRefresh = async (refresh: string, source: LoginSource, systems: boolean=false)=>{
	var res = await post<UserLogin>('refresh', { refresh, source, systems });
	if(res.error || !res.data?.tokens) return res;
	dispatchLoginEvent(res.data);
	return res;
}

var sendForgot = (email: string, source: LoginSource, captcha: string)=>{
	return post<boolean>('forgot', { email, source, captcha })
}

var changePassword = (token: string, current_password: string, new_password: string)=>{
	return post<boolean>('password', { current_password, new_password, token });
}

var verifyToken = (token: string) => {
	return post<{
		used: boolean,
		user_id: number,
		admin: boolean,
		email: string
	}>('recover/token', { token });
}

var recoverPassword = (token: string, new_password: string) => {
	return post<boolean>('recover', { new_password, token });
}

interface CreateAccountData{
	first_name: string,
	last_name: string,
	email: string,
	password: string,
	captcha: string,
}
var createAccount = (data: CreateAccountData)=>{
	return post<boolean>('create', data);
}

var confirmAccount = (token: string)=>{
	return post('confirm', { token });
}

var getUserCompleteInfo = (token: string)=>{
	return post('password/token', { token });
}

export default {
	changePassword,
	confirmAccount,
	createAccount,
	getUserCompleteInfo,
	login,
	loginRefresh,
	recoverPassword,
	sendForgot,
	verifyToken,
}